import React, {Component} from 'react';
import {withNamespaces} from "react-i18next";
import {Carousel, CarouselControl, CarouselIndicators, CarouselItem} from "reactstrap";
import SLightbox from "../SLightbox/SLightbox";

class SCarousel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            index: props.defaultIndex || 0,
        };

        if (props.lightbox) {
            this.slightbox = React.createRef();
        }
    }

    next = () => {
        const {items} = this.props;

        if (this.state.animating) return;
        const index = this.state.index === items.length - 1 ? 0 : this.state.index + 1;
        this.setIndex(index);
    };

    prev = () => {
        const {items} = this.props;

        if (this.state.animating) return;
        const index = this.state.index === 0 ? items.length - 1 : this.state.index - 1;
        this.setIndex(index);
    };

    goTo = (index) => {
        if (this.state.animating) return;
        this.setIndex(index);
    };

    setAnimating = (animating) => {
        this.setState({
            animating,
        });
    };

    setIndex = (index) => {
        this.setState({
            index,
        });
    };

    render() {
        const {t, items, alt, interval, lightbox} = this.props;

        if (!Array.isArray(items)) return null;

        return (
            <>
                <Carousel
                    activeIndex={this.state.index}
                    next={this.next}
                    previous={this.prev}
                    interval={interval || null}
                >
                    <CarouselIndicators
                        items={items.map((item, index) => ({key: index}))}
                        activeIndex={this.state.index}
                        onClickHandler={this.goTo}
                    />
                    {items.map((item, index) => (
                        <CarouselItem
                            onExiting={() => this.setAnimating(true)}
                            onExited={() => this.setAnimating(false)}
                            key={index}
                        >
                            <img
                                src={item.url} alt={alt || ''}
                                width="100%"
                                onClick={(e) => {
                                    if (lightbox) {
                                        this.slightbox.current.openLightbox(index, e);
                                    }
                                }}
                            />
                        </CarouselItem>
                    ))}
                    <CarouselControl direction="prev" directionText={t('grid.previous')} onClickHandler={this.prev} />
                    <CarouselControl direction="next" directionText={t('grid.next')} onClickHandler={this.next} />
                </Carousel>
                {items && lightbox &&
                <SLightbox
                    ref={this.slightbox}
                    images={items}
                />
                }
            </>
        );
    }

}

export default withNamespaces('common')(SCarousel);